<div class="h-[100%] bg-gray-50 py-6">
  <div class="w-full bg-gray-50">
    <div class="mx-auto w-full min-w-screen-m max-w-screen-2xl px-4 sm:px-6 md:px-8 lg:px-8 xl:px-16 2xl:px-24 xl:pb-8">

      <!-- Search & Actions -->
      <div class="sticky top-[65px] z-40 bg-gray-50 pt-7 pb-5">
        <div class="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div class="flex flex-1 items-center gap-4 w-full sm:w-auto">
            <div class="relative w-full">
              <i class="pi pi-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
              <ng-container *ngIf="searchTerm">
                <span #searchChip
                  class="absolute left-10 top-1/2 -translate-y-1/2 flex items-center bg-gray-200 rounded-full px-2 py-0.5 text-sm text-gray-700 z-10">
                  {{ searchTerm }}
                  <button type="button" (click)="clearSearch()"
                    class="ml-1 text-gray-500 hover:text-gray-700 focus:outline-none">
                    <i class="pi pi-times text-xs"></i>
                  </button>
                </span>
              </ng-container>
              <input id="transaction-search-input" type="text" placeholder="Search" [formControl]="searchControl"
                [style.paddingLeft.px]="inputPaddingLeft" (keyup.enter)="onSearch()" maxlength="40"
                class="w-full pr-8 py-2 border border-gray-300 rounded-lg focus:outline-none placeholder-gray-500 bg-white disabled:bg-gray-100 transition-all" />
            </div>
            <button id="transaction-search-button" class="px-4 py-2 rounded-lg border transition-colors" [ngClass]="{
              'bg-white border-gray-300 text-gray-800 hover:bg-gray-100 cursor-pointer':
                isSearchEnabled(),
              'bg-gray-200 border-gray-200 text-gray-400 cursor-not-allowed':
                !isSearchEnabled()
            }" [disabled]="!isSearchEnabled()" (click)="onSearch()">
              Search
            </button>
          </div>
          <div class="flex items-center gap-2" *ngIf="searchTerm">

          </div>
          <button id="transaction-new-button"
            class="bg-gray-800 text-white px-6 py-2 rounded-lg font-medium flex items-center gap-2 hover:bg-gray-900 transition-colors cursor-pointer"
            (click)="openNewTransactionDialog()">
            <i class="pi pi-plus"></i> New Transaction
          </button>
        </div>
      </div>

      <!-- Table Container -->
      <div id="transaction-table-container"
        class="bg-white rounded-lg overflow-hidden mt-10 flex flex-col xl:h-[43.2rem] lg:h-[43.2rem] md:h-[43.2rem] border border-gray-300"
        style="max-width: 100%; position: relative;">
        <!-- Spinner Centered in Table -->
        <app-spinner [isLoading]="isLoading" *ngIf="isLoading"
          style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 40; display: flex; align-items: center; justify-content: center;"></app-spinner>
        <!-- Static Header -->
        <div class="sticky top-0 z-30 bg-[#E5E1D7] border-b border-gray-300">
          <div class="flex w-full table-fixed min-w-[850px]">
            <div
              class="w-[15%] px-4 py-3 text-left text-xs sm:text-lg font-bold text-gray-700 rounded-tl-lg bg-[#E5E1D7]">
              File Number
            </div>
            <div class="w-[13%] px-4 py-3 text-left text-xs sm:text-lg font-bold text-gray-700 bg-[#E5E1D7]">
              Proof ID
            </div>
            <div class="w-[25%] px-4 py-3 text-left text-xs sm:text-lg font-bold text-gray-700 bg-[#E5E1D7]">
              Name
            </div>
            <div
              class="w-[13%] px-4 py-3 text-left text-xs sm:text-lg font-bold text-gray-700 bg-[#E5E1D7] flex items-center">
              Status
              <button type="button" (click)="toggleStatusFilter()" class="p-1 rounded cursor-pointer flex items-center">
                <i class="pi pi-filter text-sm"></i>
              </button>
              <!-- Wrapper for button and dropdown -->
              <div class="relative">
                <!-- Dropdown -->
                <div *ngIf="showStatusFilter"
                  class="absolute z-50 top-full left-0 mt-1 bg-white border border-gray-300 rounded shadow-lg p-3  max-w-xs">
                  <div class="flex flex-col gap-2">
                    <!-- Select All Option -->
                    <div class="border-b border-gray-200 pb-1">
                      <label class="flex items-center gap-2 font-medium text-sm">
                        <input type="checkbox" class="accent-[#E5E1D7]" [checked]="isAllStatusesSelected()"
                          [indeterminate]="isSomeStatusesSelected()" (change)="toggleSelectAll()" />
                        Select All
                      </label>
                    </div>

                    <!-- Status List -->
                    <div class="flex flex-col gap-1 max-h-56 overflow-y-auto text-sm font-[Inter] cursor-pointer">
                      <ng-container *ngFor="let status of getStatusEnumValues()">
                        <label class="flex items-center gap-2 font-medium text-sm">
                          <input type="checkbox" class="accent-[#E5E1D7]"
                            [checked]="selectedStatuses.includes(status.value)"
                            (change)="handleStatusCheckboxChange(status.value, $event)" />
                          {{ status.key }}
                        </label>
                      </ng-container>
                    </div>

                    <!-- Close Button aligned to bottom-right -->
                    <div class="flex justify-end pt-1">
                      <button type="button"
                        [class]="isCloseButtonEnabled() ? 'bg-gray-800 text-white hover:bg-gray-900 cursor-pointer' : 'bg-gray-300 text-gray-500 cursor-not-allowed'"
                        class="px-3 py-1 rounded-lg font-medium flex items-center gap-2 transition-colors"
                        [disabled]="!isCloseButtonEnabled()" (click)="closeStatusFilterAndRefresh()">
                        <span class="text-sm">Close</span>
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="w-[13%] px-4 py-3 text-left text-xs sm:text-lg font-bold text-gray-700 bg-[#E5E1D7]">
              Date Created
            </div>
            <div class="w-[12%] px-4 py-3 text-left text-xs sm:text-lg font-bold text-gray-700 bg-[#E5E1D7]">
              Report
            </div>
            <div
              class="w-[9%] px-4 py-3 text-right text-xs sm:text-lg font-bold text-gray-700 rounded-tr-lg bg-[#E5E1D7]">
              Actions
            </div>
          </div>
        </div>

        <div class="flex-1 overflow-x-auto overflow-y-auto">
          <table class="w-full min-w-[850px]">
            <tbody class="bg-white">
              <ng-container *ngIf="pagedTransactions.length > 0; else noData">
                <tr *ngFor="let transaction of pagedTransactions; let i = index" class="border-b border-gray-100">
                  <td
                    class="w-[15%] px-4 py-3 text-lg text-gray-900 whitespace-nowrap overflow-hidden text-ellipsis max-w-0"
                    [attr.title]="transaction.fileNumber">
                    {{ transaction.fileNumber }}
                  </td>
                  <td
                    class="w-[13%] px-4 py-3 text-lg text-gray-900 whitespace-nowrap overflow-hidden text-ellipsis max-w-0"
                    [attr.title]="transaction.providerReferenceId">
                    {{ transaction.providerReferenceId || '-' }}
                  </td>
                  <td
                    class="w-[25%] px-4 py-3 text-lg text-gray-900 whitespace-nowrap overflow-hidden text-ellipsis max-w-0"
                    [attr.title]="getFullName(transaction)">
                    {{ getFullName(transaction) }}
                  </td>
                  <td class="w-[13%] px-4 py-3 whitespace-nowrap">
                    <span class="px-3 py-1 text-xs font-semibold rounded-full border inline-block text-nowrap"
                      [ngClass]="getStatusClass(transaction.status)">
                      {{ transaction.status }}
                    </span>
                  </td>
                  <td
                    class="w-[13%] px-4 py-3 text-lg text-gray-600 whitespace-nowrap overflow-hidden text-ellipsis max-w-0">
                    {{ transaction.createdDate | date: 'MMMM d, y' }}
                  </td>
                  <td class="w-[12%] px-3 py-3 text-lg text-gray-900 whitespace-nowrap max-w-0">
                    <div
                      class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded transition-colors duration-200 group"
                      [class.cursor-pointer]="getStatusText(transaction.status) === 'Completed' || getStatusText(transaction.status) === 'Failed'"
                      [class.text-gray-400]="getStatusText(transaction.status) !== 'Completed' && getStatusText(transaction.status) !== 'Failed'"
                      [class.cursor-not-allowed]="getStatusText(transaction.status) !== 'Completed' && getStatusText(transaction.status) !== 'Failed'"
                      [class.hover:bg-gray-100]="getStatusText(transaction.status) === 'Completed' || getStatusText(transaction.status) === 'Failed'">
                      <i class="pi pi-file-pdf"
                        [class.text-gray-400]="getStatusText(transaction.status) !== 'Completed' && getStatusText(transaction.status) !== 'Failed'"></i>
                      <span
                        (click)="(getStatusText(transaction.status) === 'Completed' || getStatusText(transaction.status) === 'Failed') ? viewReport(i) : null">View
                        Report</span>
                    </div>
                  </td>
                  <td class="w-[9%] p-4 py-3 text-lg text-gray-900 text-center relative max-w-0"
                    (click)="getStatusText(transaction.status) !== 'Completed' && getStatusText(transaction.status) !== 'Failed' && getStatusText(transaction.status) !== 'Expired' ? openDropdownIndex = i : null"
                    (mouseleave)="openDropdownIndex = null">
                    <div class="focus:outline-none">
                      <i class="pi pi-ellipsis-h cursor-pointer"
                        [class.cursor-pointer]="getStatusText(transaction.status) !== 'Completed' && getStatusText(transaction.status) !== 'Failed' && getStatusText(transaction.status) !== 'Expired'"
                        [class.text-gray-400]="getStatusText(transaction.status) === 'Completed' || getStatusText(transaction.status) === 'Failed' || getStatusText(transaction.status) === 'Expired'"
                        [class.cursor-not-allowed]="getStatusText(transaction.status) === 'Completed' || getStatusText(transaction.status) === 'Failed' || getStatusText(transaction.status) === 'Expired'"
                        [class.hover:bg-gray-100]="getStatusText(transaction.status) !== 'Completed' && getStatusText(transaction.status) !== 'Failed' && getStatusText(transaction.status) !== 'Expired'">
                      </i>
                    </div>
                    <div *ngIf="openDropdownIndex === i"
                      class="absolute top-0 right-0 mb-2 w-50 bg-white border border-gray-200 rounded shadow-lg z-20 text-sm">
                      <button class="flex items-center w-full px-4 py-2" (click)="resendSms(i)"
                        [class.cursor-pointer]="transaction.phoneNumberProvided"
                        [class.text-gray-400]="!transaction.phoneNumberProvided"
                        [class.cursor-not-allowed]="!transaction.phoneNumberProvided"
                        [class.hover:bg-gray-100]="transaction.phoneNumberProvided">
                        <i class="pi pi-mobile mr-2"></i> Resend SMS
                      </button>
                      <button
                        class="flex items-center w-full px-4 py-2 hover:bg-gray-100 text-gray-800 text-sm cursor-pointer"
                        (click)="resendEmail(i)">
                        <i class="pi pi-envelope mr-2"></i> Resend e-mail
                      </button>
                      <button class="flex items-center w-full px-4 py-2 hover:bg-gray-100 text-sm cursor-pointer"
                        (click)="deleteTransaction(i)">
                        <i class="pi pi-trash mr-2"></i> Delete Transaction
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-container>

              <ng-template #noData>
                <tr>
                  <td *ngIf="!isLoading" colspan="7" class="h-[30.2rem]">
                    <div class="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg class="w-16 h-16 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      <p class="text-xl font-medium">No transactions found</p>
                      <p class="text-base mt-2">Try adjusting your search or create a new transaction</p>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
        <!-- Table Footer -->
        <div id="transaction-table-footer"
          class="flex flex-col sm:flex-row items-center justify-between px-4 sm:px-6 py-4 xl:py-4 2xl:py-4 bg-[#E5E1D7] border-t border-gray-300">
          <div class="flex items-center gap-2">
            <label for="transaction-rows-per-page-selector" class="text-lg text-gray-700">Display Rows:</label>
            <select id="transaction-rows-per-page-selector"
              class="border border-gray-300 rounded px-2 py-1 text-lg text-gray-700 bg-white focus:outline-none cursor-pointer"
              (change)="changeRowsPerPage($event)">
              <option value="10" [selected]="rowsPerPage === 10">10</option>
              <option value="25" [selected]="rowsPerPage === 25">25</option>
              <option value="50" [selected]="rowsPerPage === 50">50</option>
            </select>
          </div>
          <div class="flex items-center gap-4 mt-2 sm:mt-0">
            <div id="transaction-pagination-info" class="text-lg text-gray-700">
              Showing {{ showingFrom }}-{{ showingTo }} of {{ totalCount }} transactions
            </div>
            <div class="flex gap-1">
              <button id="transaction-pagination-prev"
                class="w-8 h-8 flex items-center justify-center rounded border border-gray-300"
                [ngClass]="{
                  'bg-white text-gray-700 cursor-pointer': currentPage > 1,
                  'bg-gray-200 text-gray-400 cursor-not-allowed': currentPage === 1
                }"
                [disabled]="currentPage === 1" (click)="changePage(currentPage - 1)">
                &lt;
              </button>
              <button *ngFor="let page of [].constructor(totalPages); let i = index"
                class="w-8 h-8 flex items-center justify-center rounded border border-gray-300 cursor-pointer"
                [ngClass]="{
                  'bg-gray-800 text-white font-bold': currentPage === i + 1,
                  'bg-white text-gray-700': currentPage !== i + 1
                }" (click)="changePage(i + 1)">
                {{ i + 1 }}
              </button>
              <button id="transaction-pagination-next"
                class="w-8 h-8 flex items-center justify-center rounded border border-gray-300"
                [ngClass]="{
                  'bg-white text-gray-700 cursor-pointer': currentPage < totalPages,
                  'bg-gray-200 text-gray-400 cursor-not-allowed': currentPage === totalPages
                }"
                [disabled]="currentPage === totalPages" (click)="changePage(currentPage + 1)">
                &gt;
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-create-transaction-dialog [show]="showCreateTransactionDialog" (close)="showCreateTransactionDialog = false"
  (submitTransaction)="onTransactionCreated($event)" (error)="onTransactionCreateError()">
</app-create-transaction-dialog>

<app-action-result-dialog [show]="showResultDialog" [fileNumber]="fileNumber" [agency]="createdAgency"
  [isError]="resultDialogIsError" [action]="action" [showBack]="resultDialogShowBack" (close)="onResultDialogClose()"
  (back)="onResultDialogBack()" [size]="this.errorDialogSize" [position]="this.errorDialogPosition">
</app-action-result-dialog>

<app-delete-transaction-dialog [show]="showDeleteTransactionDialog" [fileNumber]="fileNumber"
  [transactionId]="transactionId" (close)="closeDeleteTransactionDialog()" (error)="onDeleteTransactionError()"
  (confirmDelete)="confirmDeleteTransaction()">
</app-delete-transaction-dialog>

<app-sms-resend-dialog [show]="showConfirmSmsResendDialog" [transactionId]="transactionId" (error)="onSmsResendError()"
  [recipientName]="recipientName" [showHeader]="false" (close)="closeConfirmSmsResendDialog()"
  (confirmResend)="confirmResendSms()">
</app-sms-resend-dialog>

<app-email-resend-dialog [show]="showEmailResendDialog" [transactionId]="transactionId" [recipientName]="recipientName"
  [fileNumber]="fileNumber" [showHeader]="true" (close)="closeEmailResendDialog()" (error)="onEmailResendError()"
  (confirmResend)="confirmResendEmail()">
</app-email-resend-dialog>

<app-view-report-dialog [show]="showViewReportDialog" [fileNumber]="fileNumber" [showHeader]="true" [pdfUrl]="pdfUrl"
  (close)="closeViewReportDialog()" (confirmResend)="confirmViewReport()">
</app-view-report-dialog>